import type { Transaction } from '@shared/transactions-types';
import {
    BookingType,
    RoundingType,
    SepaScheme,
    TransactionDirection,
    TransactionOrderCategory,
    TransactionType,
} from '@shared/transactions-types';
import { CardType } from '@shared/cards-types';

export const mockTransaction: Transaction = {
    bookingType: BookingType.HCT_POS_OUT_NOA,
    bookingTypeTranslation: '',
    roundingType: RoundingType.SAVING,
    roundingAmount: {
        value: 1000,
        precision: 2,
        currency: 'EUR',
    },
    cardId: '',
    cardBrand: '',
    cardType: CardType.MAIN,
    categories: [],
    creditorId: '',
    flags: [],
    id: '',
    loanReference: '',
    logo: { id: 0, uri: '', requiresAuthentication: false },
    mandateId: '',
    maskedCardNumber: '404857XXXXXX5704',
    orderCategory: TransactionOrderCategory.DOMESTIC,
    posData: null,
    receiver: {
        iban: 'Receiver IBAN',
        bic: 'Receiver BIC',
        bankCode: '0000',
        number: '1234',
        prefix: '000',
    },
    receiverAddress: [],
    receiverModeReference: '',
    receiverIdentificationReference: 'Receiver id reference',
    receiverName: '',
    receiverReference: '',
    sender: {
        iban: 'Sender IBAN',
        bic: 'Sender BIC',
        bankCode: '0000',
        number: '1234',
        prefix: '000',
    },
    senderName: 'Sender name',
    senderAddress: [],
    senderModeReference: '',
    senderOriginator: 'Ultimate Debtor',
    senderIdentificationReference: 'Sender id reference',
    senderBankReference: 'Sender bank reference',
    sepaPurposeType: 'OTHR',
    title: '',
    subtitle: '',
    extraSubtitles: [],
    txDirection: TransactionDirection.INCOMING,
    txType: TransactionType.ATM,

    bookingDate: '2021-09-10',
    owner: 'AT090000000000000453',
    ownerName: 'Owner of card',
    ownerOriginator: 'Camp Nou GmbH',
    amount: {
        value: 1000,
        precision: 2,
        currency: 'EUR',
    },
    partner: {
        iban: 'Partner IBAN',
        bic: 'Partner BIC',
        bankCode: '0000',
        number: '1234',
        prefix: '000',
    },
    partnerName: 'Some name',
    paymentReference: 'Mark & spencer',
    reference: '',
    note: 'Sweet note',
    tags: [],
    additionalData: {
        marked: false,
    },
    valuationDate: '2021-09-11',
    transactionDateTime: 1631442896000, // 2021-09-12T12:34:56+0200
    additionalTexts: {
        constantSymbol: '120',
        specificSymbol: 'SS 33',
        variableSymbol: 'VS345',
    },
    card: {
        location: 'LONDON',
    },
    virtualCard: {
        virtualCardNumber: '0000 0000 0000 0000',
        deviceName: '456456',
        mobilePaymentApplicationName: '',
    },
    partnerAddress: ['Am Belvedere 1', '1100 Wien'],
    partnerOriginator: 'Partner Originator',
    senderReference: 'Reference to Sender',
    partnerReference: '607823031725',
    balance: {
        value: 123456.78,
        precision: 2,
        currency: 'EUR',
    },
    sepaRecurrence: 'Direct Debit',
    originatorSystem: 'SD*/UEW',
    amountSender: {
        value: 1050,
        precision: 2,
        currency: 'USD',
    },
    exchangeDate: '2021-09-11',
    exchangeRateValue: 1050,
    exchangeRatePrecision: 3,
    foreignExchangeFee: {
        value: 100,
        precision: 2,
        currency: 'EUR',
    },
    transactionFee: {
        value: 50,
        precision: 2,
        currency: 'EUR',
    },
    sepaScheme: SepaScheme.INSTANT_PAYMENT,
    sepaE2eReference: 'SEPA E2E Reference',
    location: 'Vienna',
    fee: {
        amount: {
            value: 1.23,
            precision: 2,
            currency: 'EUR',
        },
        type: 'fee type',
    },
    cardCashbackAmount: {
        value: 1.234,
        precision: 3,
        currency: 'EUR',
    },
    ultimateCreditor: null,
    ultimateDebtor: null,
    instantPayment: false,
    merchantName: 'Merchant Name',
    billId: 202100009,
    similarityKey: '9C3B82F6000AA9D04744E3B350D1E632',
};
